import { put, call, takeLatest, select } from 'redux-saga/effects';
import { GET_SIMCARD_REQUEST, getSimcardSuccess, getSimcardFailure } from '../actions/simcards';
import { getSimcards } from '../services/simcards';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getSimcardWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { simcards }
        } = yield call(getSimcards, filters, token);

        yield put(getSimcardSuccess(simcards[0] || {}));
    } catch (err) {
        yield put(getSimcardFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [takeLatest(GET_SIMCARD_REQUEST, getSimcardWorker)];
